import * as React from 'react';

import { RouteStore } from 'bernie-core';

import { SearchResultsStore } from 'stores/search-results-store';

import { HotelViewModel, InsightsViewModel } from 'models';
import { ResultType } from 'constants/resultType';

import { AlternateDestinations, AlternateDestinationsProps } from './alternate-destinations';
import { MesoNativeResultListing } from 'components/meso/meso-native-results-listing';
import { MessagingCardProps } from 'components/common/messaging-card';
import { RegionCompressionCard } from 'components/common/region-compression-card';
import { Result } from './result';
import * as queue from 'components/common/media/image-queue';

const LOADING_LIST = new Array(6).fill({});
const LAZY_LOADING_IMAGE_INDEX = 3;
const REGION_COMPRESSION_INDEX = 3;
const NRL_POS = 11;
const KEY_PREFIX = 'resultListing';
const MESSAGE_KEY_PREFIX = 'resultMessageListing';
const PROPERTY_TYPE_CAROUSEL_INDEX = 3;

export interface ResultsProps {
  hotels: HotelViewModel[];
  loading: boolean;
  startDate: string;
  endDate: string;
  insights?: InsightsViewModel;
  setResultRef: (ref: HTMLElement, index: number) => void;
  className?: string;
  hotelListings: HotelViewModel[];
  messageListings: MessagingCardProps[];
  searchResults: SearchResultsStore;
  alternateDestinations?: AlternateDestinationsProps;
  routeStore?: RouteStore;
}

export class Results extends React.Component<ResultsProps> {
  public constructor(props) {
    super(props);
  }

  public componentWillUnmount() {
    queue.dequeueAll('HSR');
  }

  public render() {
    const {
      loading,
      insights,
      hotels,
      setResultRef,
      className,
      endDate,
      startDate,
      hotelListings,
      messageListings,
      alternateDestinations,
      searchResults,
      routeStore
    } = this.props;
    const compression = insights && insights.compression;
    const dateOptions = insights && insights.alternateDateOptions;
    const showLoadingList = loading && (!hotels || hotels.length === 0);
    const classNames = `listing ${className}`;
    const messageMap = messageListings.reduce((obj, singleMessage) => {
      obj[singleMessage.index] = singleMessage;

      return obj;
    }, {});

    if (searchResults.propertyTypeCarousel) {
      messageMap[PROPERTY_TYPE_CAROUSEL_INDEX] = {
        model: searchResults.propertyTypeCarousel,
        resultType: ResultType.CAROUSEL
      };
    }

    const truncatedHotelListings = showLoadingList ? LOADING_LIST : hotelListings.slice(0, this.props.searchResults.hotelsMaxDisplay);
    let unavailableCount = 0;

    return (
      <section className="results" data-stid="section-results">
        <ol className="uitk-grid all-x-gutter-three all-y-gutter-three results-list">
          {truncatedHotelListings.map((listing, index) => {
            const resultProps = {
              className: classNames,
              endDate,
              startDate,
              index,
              lazyLoadImg: index >= LAZY_LOADING_IMAGE_INDEX,
              loading: showLoadingList,
              setResultRef,
              routeStore
            };
            unavailableCount = !listing.hasAvailableOffer ? unavailableCount + 1 : unavailableCount;

            return (
              <React.Fragment key={`${KEY_PREFIX}-${index}`}>
                {index === NRL_POS && <MesoNativeResultListing className={className} uci="NRL" errorBoundaryLabel="hotel.search.meso" />}

                {compression &&
                  index === REGION_COMPRESSION_INDEX && (
                    <li className={classNames}>
                      <RegionCompressionCard key="region-compression-card" compression={compression} dateOptions={dateOptions} />
                    </li>
                  )}

                {messageMap[index] && (
                  <Result
                    {...resultProps}
                    // we need the unique combination since sponsored listings can present a duplicate hotelId in the same list
                    key={`${MESSAGE_KEY_PREFIX}-${index}`}
                    model={messageMap[index].model}
                    resultType={messageMap[index].resultType ? messageMap[index].resultType : ResultType.MESSAGING}
                  />
                )}

                {!loading &&
                  alternateDestinations &&
                  unavailableCount === SearchResultsStore.ALTERNATE_DESTINATIONS_UNAVAILABLE_INDEX && (
                    <AlternateDestinations {...alternateDestinations} />
                  )}

                <Result
                  {...resultProps}
                  // we need the unique combination since sponsored listings can present a duplicate hotelId in the same list
                  key={listing.id ? `${KEY_PREFIX}-${listing.id}-${index}` : `${KEY_PREFIX}-${index}`}
                  model={listing.model || listing} // MessagingCard | Listing
                  resultType={listing.resultType}
                />
              </React.Fragment>
            );
          })}
        </ol>
      </section>
    );
  }
}
